import * as React from 'react';
import { escapeRegExp } from 'lodash';

import { ChangeHandler } from 'types/typescript/eventHandlers';
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Dialog from 'components/Dialog';
import Field from 'components/Field';
import Input from 'components/Input';
import QuickPromotion from 'entities/QuickPromotion';
import TitleHeader from 'components/TitleHeader';

type Props = {
  promotion: QuickPromotion;
  onConfirm: (data: any) => void;
  onDialogDismiss: () => any;
  onRequestHide: () => any;
};

type State = {
  email: string;
  error: string;
};

class SisMergeExistingTeacherModal extends React.Component<Props, State> {
  state = {
    email: '',
    error: '',
  };

  handleConfirm = () => {
    const emailDomain = this.getEmailDomain();
    const regexp = new RegExp(`.+@${escapeRegExp(emailDomain)}$`);
    if (regexp.test(this.state.email)) {
      this.props.onRequestHide();
      this.props.onConfirm({ teacher_email: this.state.email });
    } else {
      this.setState({ error: `Your email must be an @${emailDomain} address` });
    }
  };

  setTeacherEmail: ChangeHandler<HTMLInputElement> = event => {
    const email = event.target.value;
    this.setState({ email });
  };

  getEmailDomain = (): string | undefined => {
    const promotionData = this.props.promotion.getData();
    const teacherEmailDomain = promotionData['email_domain'];
    return teacherEmailDomain;
  };

  render() {
    const emailDomain = this.getEmailDomain();
    if (!emailDomain) {
      console.error(
        'SisMergeExistingTeacherModal - tried to render without an official email domain'
      );
      return null;
    }

    return (
      <Dialog
        eventScreenName="SisMergeExistingTeacherModal"
        className="SisMergeExistingTeacherModal"
        size="small"
        hideOnBlur={false}
        onDialogDismiss={this.props.onDialogDismiss}
        onRequestHide={this.props.onRequestHide}>
        <BoxBody>
          <TitleHeader
            title={this.props.promotion.getHeader()}
            subtext={this.props.promotion.getBody()}
            image={this.props.promotion.getImageUrl()}
          />
          <Field className="SisMergeExistingTeacherModal-field" error={this.state.error}>
            <Input
              name="teacher_email"
              className="SisMergeExistingTeacherModal-input"
              placeholder={`email@${emailDomain}`}
              value={this.state.email}
              onChange={this.setTeacherEmail}
            />
          </Field>
          <Button
            full
            data-test="submit-button"
            eventElementName="QuickPromotion-confirm"
            className="SisMergeExistingTeacherModal-submit"
            onClick={this.handleConfirm}>
            Submit
          </Button>
        </BoxBody>
      </Dialog>
    );
  }
}

export default SisMergeExistingTeacherModal;
